const VALVE_SIZE_VALUES = ['1/4', '3/8', '1/2', '3/4', '1', '11/4', '11/2', '2', '21/2', '3', '4', '5', '6', '8', '10', '12', '14', '16', '18', '20', '24', '26', '28', '30', '32', '36', '40'];
const buildValveSizeDropdownOptions = () => {
    const defaultOption = { name: 'Select Valve Size', value: '' };
    const sizeOptions = VALVE_SIZE_VALUES.map(size => ({
            name: size,
            value: size
    }));
    return [defaultOption, ...sizeOptions];
};

export const ValveSectionDataP51 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F340ValveSize',
                    label: 'Valve Size (NPS)',
                    value: selectedTag.DateTested ? formData?.F340ValveSize : formData?.F340ValveSize ?? String(selectedTag?.ValveSizeNps ?? ''),
                    options: buildValveSizeDropdownOptions(),
                    labelWidth: '57.9%',
                    width: '42.6%',
                    isDropdown: true,
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    isRequired: true,
                    marginTop: '15px',
                    type: 'number',
                    borderBottom: '0',
                    textAlign: 'center',
                    placeholder: 'Select Valve Size',
                },
                {
                    key: 'F1075ValvePressureClass',
                    label: 'Valve Pressure Class (#)',
                    value: selectedTag.DateTested ? formData?.F1075ValvePressureClass : formData?.F1075ValvePressureClass ?? selectedTag?.ValvePressureClass,
                    labelWidth: '100%',
                    xs: 6,
                    textAlignLabel: 'end',
                    maxLength: '10',
                    isRequired: true,
                    marginRight: '5px',
                    marginTop: '15px',
                    width: '74.5%',
                    type: 'number',
                    borderBottom: '0',
                    textAlign: 'center',
                    height: '1.25rem'
                }
            ]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F1076UniqueValveId',
                    label: 'Unique Valve ID',
                    value: selectedTag.DateTested ? formData?.F1076UniqueValveId : formData?.F1076UniqueValveId ?? selectedTag?.ValveId,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '30',
                    isRequired: true,
                    width: '71.1%',
                    textAlign: 'center',
                    height: '1.25rem'
                },
                {
                    key: 'F602ValveType',
                    label: 'Valve Type',
                    value: selectedTag.DateTested ? formData?.F602ValveType : formData?.F602ValveType ?? selectedTag?.DeviceType,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    maxLength: '30',
                    isRequired: true,
                    textAlignLabel: 'end',
                    width: '74.5%',
                    marginRight: '5px',
                    height: '1.25rem',
                    textAlign: 'center',
                }
            ]
        }
    ]
});
